import React from 'react';
import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';

import { units } from '../theme/units';

const OPENING_BRACKET = '\u201c';
const CLOSING_BRACKET = '\u201d';

const styles = (theme: Theme) =>
  createStyles({
    blockquote: {
      position: 'relative',
      color: theme.palette.secondary.main,
      marginTop: units.rem(2.5),
      marginBottom: units.rem(2.5),
    },
    quoteStart: {
      fontSize: '10rem',
      position: 'absolute',
      lineHeight: units.rem(1),
      top: units.rem(3),
      [theme.breakpoints.between('xs', 'sm')]: {
        fontSize: units.rem(6),
        top: units.rem(2),
        left: units.rem(1),
      },
    },
    quote: {
      padding: units.yx(0, 6),
      textAlign: 'center',
      '& > *': {
        fontSize: units.rem(2),
        color: theme.palette.secondary.main,
      },
      [theme.breakpoints.between('xs', 'sm')]: {
        padding: units.rem(2),
      },
    },
    quoteEnd: {
      fontSize: units.rem(10),
      position: 'absolute',
      lineHeight: units.rem(1),
      bottom: 0,
      right: 0,
      [theme.breakpoints.between('xs', 'sm')]: {
        fontSize: units.rem(6),
        right: units.rem(1),
        bottom: units.rem(2),
      },
    },
  });

const MarkdownBlockquoteInternal: React.FC<WithStyles<typeof styles>> = ({
  children,
  classes,
}) => (
  <blockquote className={classes.blockquote}>
    <div className={classes.quoteStart}>{OPENING_BRACKET}</div>
    <div className={classes.quote}>{children}</div>
    <div className={classes.quoteEnd}>{CLOSING_BRACKET}</div>
  </blockquote>
);

const MarkdownBlockquote = withStyles(styles)(MarkdownBlockquoteInternal);
export { MarkdownBlockquote };
